export default __webpack_public_path__ + "static/media/orchid_tracking-blue.210eaa0c.svg";